import Panel from '../panel';
import { charsetEscape, detectLanguage, translate } from '../utils/translate';
import { log, logMethodCall } from '../utils/debug';
import SubscribingInProgressError from '../error/SubscribingInProgressError';

require('./bell.scss');

export default class Bell {
  constructor(config, subscriptionManager, api, confirm, triggerEvent, triggerOptIn) {
    this.config = config;
    this.subscriptionManager = subscriptionManager;
    this.isSubscribed = this.subscriptionManager.subscribed;
    this.api = api;
    this.confirm = confirm;
    this.triggerEvent = triggerEvent;
    this.triggerOptIn = triggerOptIn;

    this.localization = this.getLocalization();

    this.show = this.show.bind(this);
    this.reset = this.reset.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  initCleverPushTrigger() {
    if (this.config.urlTriggeredPanelTab) {
      this.showPanel();
    }
  }

  getClassName() {
    let className = 'cleverpush-bell';
    if (this.config.notificationBellPosition) {
      className += ` cleverpush-bell-position-${this.config.notificationBellPosition}`;
    }
    if (this.config.notificationBellPositionY) {
      className += ` cleverpush-bell-position-${this.config.notificationBellPositionY}`;
    }
    return className;
  }

  initPrompt() {
    if (this.promptInited || this.isSubscribed || window.innerWidth < 768 || localStorage.getItem('cleverpush-bell-prompt-denied')) {
      return;
    }
    this.promptInited = true;

    const localization = this.confirm.getLocalization({});

    this.prompt = document.createElement('div');
    this.prompt.className = 'cleverpush-bell-prompt';
    this.prompt.innerHTML = `
    <div class="cleverpush-bell-prompt-icon" style="background-image: url('${this.config.channelIcon}')"></div>
    <div class="cleverpush-bell-prompt-content">
      <div class="cleverpush-bell-prompt-title">
      ${localization.title}
      </div>
      <div class="cleverpush-bell-prompt-buttons">
      <button class="cleverpush-confirm-btn cleverpush-confirm-btn-deny">${localization.deny}</button>
        <button class="cleverpush-confirm-btn cleverpush-confirm-btn-allow" style="${this.config.confirmAlertAllowButtonStyle && this.config.confirmAlertAllowButtonStyle.color ? (`color: ${this.config.confirmAlertAllowButtonStyle.color};`) : ''} ${this.config.confirmAlertAllowButtonStyle && this.config.confirmAlertAllowButtonStyle.backgroundColor ? (`border-color: transparent !important; background: none; background-color: ${this.config.confirmAlertAllowButtonStyle.backgroundColor};`) : ''}">${localization.allow}</button>
      </div>
    </div>
    `;

    this.promptAllow = this.prompt.querySelector('.cleverpush-confirm-btn-allow');
    if (this.promptAllow) {
      this.promptAllow.addEventListener('click', (e) => {
        e.preventDefault();
        this.prompt.style.display = 'none';
      });
    }
    this.promptDeny = this.prompt.querySelector('.cleverpush-confirm-btn-deny');
    if (this.promptDeny) {
      this.promptDeny.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem('cleverpush-bell-prompt-denied', `${Date.now()}`);
        this.prompt.style.display = 'none';
      });
    }

    this.bell.appendChild(this.prompt);
  }

  getLocalization() {
    let configBellLocalization = this.config.bellLocalization || {};
    const language = detectLanguage(this.config || {});
    if (this.config.bellLocalizationTranslations && language && this.config.bellLocalizationTranslations[language]) {
      configBellLocalization = { ...configBellLocalization, ...this.config.bellLocalizationTranslations[language] };
    }

    const localization = {
      subscribe: charsetEscape(configBellLocalization.subscribe) || translate('bell.subscribe'),
      subscribed: charsetEscape(configBellLocalization.subscribed) || translate('bell.subscribed'),
      hide: charsetEscape(configBellLocalization.hide) || translate('bell.hide'),
      settings: charsetEscape(configBellLocalization.settings) || translate('panel.settings'),
    };

    return localization;
  }

  show(isSubscribed) {
    logMethodCall('bell.show', isSubscribed);
    this.initCleverPushTrigger();
    this.isSubscribed = isSubscribed;

    let bellHidden = false;
    try {
      bellHidden = localStorage.getItem('cleverpush-bell-hidden') === 'true';
    } catch (e) {}
    if (bellHidden) {
      return;
    }

    let bellMessage;
    let className = this.getClassName();
    if (isSubscribed) {
      className += ' cleverpush-bell-disabled';
      bellMessage = this.localization.subscribed;

      if (this.config.hideNotificationBellSubscribed) {
        className += ' cleverpush-bell-hidden';
      }
    } else {
      bellMessage = this.localization.subscribe;
    }

    let moreButtons = '';
    if (this.config.notificationBellMoreButtons) {
      moreButtons = `<button type="button" class="cleverpush-bell-more-btn cleverpush-bell-more-settings" style="display: none"><svg viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M18.88 12.88a6.83 6.83 0 0 0 0-1.76l1.95-1.49a.45.45 0 0 0 .11-.57l-1.85-3.12c-.11-.2-.36-.27-.56-.2l-2.3.9a6.8 6.8 0 0 0-1.57-.88l-.35-2.38a.45.45 0 0 0-.46-.38h-3.7a.45.45 0 0 0-.45.38l-.35 2.38c-.57.23-1.09.53-1.57.88l-2.3-.9a.46.46 0 0 0-.57.2L3.06 9.06c-.12.2-.06.44.12.57l1.95 1.49a6.95 6.95 0 0 0 0 1.76l-1.95 1.49a.45.45 0 0 0-.12.57l1.85 3.12c.12.2.37.27.57.2l2.3-.9c.48.36 1 .65 1.57.88l.35 2.38c.03.22.22.38.45.38h3.7c.23 0 .43-.16.46-.38l.35-2.38a7.16 7.16 0 0 0 1.56-.88l2.3.9c.22.08.46 0 .57-.2l1.85-3.12a.45.45 0 0 0-.11-.57l-1.95-1.49zM12 15.15A3.2 3.2 0 0 1 8.76 12 3.2 3.2 0 0 1 12 8.85 3.2 3.2 0 0 1 15.24 12 3.2 3.2 0 0 1 12 15.15z" id="park-svg-settings-path-1"></path></defs><use xlink:href="#park-svg-settings-path-1" transform="translate(-3 -3)" stroke="none" stroke-width="1" fill-rule="evenodd"></use></svg><span class="cleverpush-tooltip">${this.localization.settings}</span></button>
<button type="button" class="cleverpush-bell-more-btn cleverpush-bell-more-subscribe" style="display: none"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
<g><path d="M380.6,989.9c-30.5,0-59.3-14.2-77.8-38.7L52.6,621C20,578,28.5,516.8,71.5,484.3c43-32.6,104.1-24.1,136.7,18.9l164.6,217.3L786.7,56c28.5-45.7,88.7-59.7,134.5-31.2c45.8,28.4,59.7,88.7,31.2,134.4L463.5,944c-17,27.4-46.4,44.5-78.5,45.9C383.6,990,382.1,990,380.6,989.9L380.6,989.9z"/></g>
</svg><span class="cleverpush-tooltip">${this.localization.subscribe}</span></button>
<button type="button" class="cleverpush-bell-more-btn cleverpush-bell-more-hide" style="display: none"><svg viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8 6.87L6.87 8 4 5.13 1.13 8 0 6.87 2.87 4 0 1.13 1.13 0 4 2.87 6.87 0 8 1.13 5.13 4z"></path></svg><span class="cleverpush-tooltip">${this.localization.hide}</span></button>
`;
    }

    this.bell = document.createElement('div');
    this.bell.className = className;
    this.bell.innerHTML = `${moreButtons}<div class='cleverpush-bell-message'>${bellMessage}</div>`;

    let bellParent = document.body;
    if (this.config.bellParentSelector) {
      bellParent = document.querySelector(this.config.bellParentSelector) || document.body;
    }
    bellParent.appendChild(this.bell);

    if (this.bell) {
      this.bell.addEventListener('click', this.onClick.bind(this));

      if (this.config.notificationBellColor && this.config.notificationBellColor.length) {
        this.bell.style.backgroundColor = this.config.notificationBellColor;
      }
      if (this.config.notificationBellOffsetTop && this.config.notificationBellPositionY !== 'bottom') {
        this.bell.style.top = `${this.config.notificationBellOffsetTop}px`;
      }
      if (this.config.notificationBellOffsetBottom && this.config.notificationBellPositionY !== 'top') {
        this.bell.style.bottom = `${this.config.notificationBellOffsetBottom}px`;
      }
      if (this.config.notificationBellOffsetLeft && this.config.notificationBellPosition !== 'right') {
        this.bell.style.left = `${this.config.notificationBellOffsetLeft}px`;
      }
      if (this.config.notificationBellOffsetRight && this.config.notificationBellPosition !== 'left') {
        this.bell.style.right = `${this.config.notificationBellOffsetRight}px`;
      }
      if (this.config.notificationBellSize) {
        this.bell.style.height = `${this.config.notificationBellSize}px`;
        this.bell.style.width = `${this.config.notificationBellSize}px`;
      }

      if (this.config.notificationBellMoreButtons) {
        this.initMoreButtons();
      }
    }

    if (this.config.showNotificationBellPrompt) {
      let showPrompt = true;
      if (this.config.notificationBellPromptVisits) {
        let visits = parseInt(localStorage.getItem('cleverpush-bell-prompt-visits'), 10) || 0;
        showPrompt = visits >= this.config.notificationBellPromptVisits;
        visits += 1;
        localStorage.setItem('cleverpush-bell-prompt-visits', `${visits}`);
      }
      if (showPrompt) {
        setTimeout(() => {
          this.initPrompt();
        }, this.config.notificationBellPromptSeconds || 0);
      }
    }
  }

  initMoreButtons() {
    this.settingsButton = this.bell.querySelector('.cleverpush-bell-more-settings');
    this.settingsButton.onclick = (e) => {
      e.stopPropagation();

      this.moreButtonsVisible = false;
      this.settingsButton.style.display = 'none';
      this.hideButton.style.display = 'none';
      if (this.config.notificationBellSettingsLink) {
        window.open(this.config.notificationBellSettingsLink, '_blank');
      } else {
        this.showPanel();
      }
    };
    this.subscribeButton = this.bell.querySelector('.cleverpush-bell-more-subscribe');
    this.subscribeButton.onclick = (e) => {
      e.stopPropagation();

      this.moreButtonsVisible = false;
      this.subscribeButton.style.display = 'none';
      this.hideButton.style.display = 'none';
      this.subscribe();
    };
    this.hideButton = this.bell.querySelector('.cleverpush-bell-more-hide');
    this.hideButton.onclick = (e) => {
      e.stopPropagation();
      this.hideForever();
    };
  }

  reset(isSubscribed) {
    logMethodCall('bell.reset', isSubscribed);

    this.isSubscribed = isSubscribed;
    this.moreButtonsVisible = false;

    if (this.bell) {
      let bellMessage;
      let className = this.getClassName();
      if (isSubscribed) {
        className += ' cleverpush-bell-disabled';

        if (this.config.hideNotificationBellSubscribed) {
          className += ' cleverpush-bell-hidden';
        }
        bellMessage = this.localization.subscribed;
      } else {
        bellMessage = this.localization.subscribe;
      }
      this.bell.className = className;
      const messageDiv = this.bell.querySelector('.cleverpush-bell-message');
      if (messageDiv) {
        messageDiv.innerHTML = bellMessage;
      }

      const loaderDiv = this.bell.querySelector('.cleverpush-loader');
      if (loaderDiv && loaderDiv.parentNode) {
        loaderDiv.parentNode.removeChild(loaderDiv);
      }

      if (this.config.notificationBellMoreButtons) {
        this.initMoreButtons();
      }
    }

    if (isSubscribed && this.prompt) {
      this.prompt.style.display = 'none';
    }
  }

  hideForever() {
    this.bell.style.setProperty('display', 'none', 'important');
    localStorage.setItem('cleverpush-bell-hidden', 'true');
  }

  showMessage(message, seconds) {
    if (this.bell) {
      const bellMessage = this.bell.querySelector('.cleverpush-bell-message');
      bellMessage.className += ' cleverpush-bell-message-open';
      bellMessage.innerHTML = message;
      setTimeout(() => {
        bellMessage.innerHTML = this.localization.subscribe;
        bellMessage.className = 'cleverpush-bell-message';
      }, seconds * 1000);
    }
  }

  showPanel() {
    if (!this.panel) {
      this.panel = new Panel(this.config, this.subscriptionManager, this.triggerEvent, this.api);
    }
    this.panel.show();
  }

  setLoading() {
    this.bell.className += ' cleverpush-bell-loading';
    this.bell.innerHTML += '<div class="cleverpush-loader"><div></div><div></div><div></div><div></div></div>';
  }

  subscribe() {
    logMethodCall('bell.subscribe');

    const notificationPermission = this.subscriptionManager.getNotificationPermission(true);
    const showBackdrop = notificationPermission === 'default';

    this.api.fromBellWidget = true;
    this.api.confirmAlertShown();

    if (!this.subscriptionManager.isSubscribing) {
      // only show backdrop if notification permission is not granted
      log.debug('showBackdrop', showBackdrop);

      if (notificationPermission !== 'denied') {
        this.setLoading();
      }

      this.triggerOptIn(true, (err) => {
        if (err) {
          this.reset(this.isSubscribed);

          if (this.config.ownDomain && location.protocol === 'https:' && (err.reason === 'denied' || err.reason === 'default')) {
            if (this.subscriptionManager.confirm) {
              this.subscriptionManager.confirm.showBackdrop(undefined, 'denied', err.message);
            }
          } else {
            log.error(err);
          }
        } else {
          this.subscriptionManager.getSubscriptionId().then((subscriptionId) => {

          });
        }
      });

      this.confirm.resetBell((allow) => {
        if (!allow) {
          this.reset(this.isSubscribed);
        }
      });
    }
  }

  toggleMoreButtons() {
    logMethodCall('bell.toggleMoreButtons');

    const messageDiv = this.bell.querySelector('.cleverpush-bell-message');

    if (this.moreButtonsVisible) {
      this.settingsButton.style.display = 'none';
      this.subscribeButton.style.display = 'none';
      this.hideButton.style.display = 'none';
      this.moreButtonsVisible = false;
      if (this.isSubscribed) {
        this.bell.className += ' cleverpush-bell-disabled';
      }

      if (messageDiv && window.innerWidth < 768) {
        messageDiv.className = 'cleverpush-bell-message';
      }

      if (window.document.activeElement) {
        window.document.activeElement.blur();
      }
    } else {
      if (this.isSubscribed) {
        this.settingsButton.style.display = 'flex';
        this.bell.className = this.getClassName();
      } else {
        this.subscribeButton.style.display = 'flex';
      }
      this.hideButton.style.display = 'flex';
      this.moreButtonsVisible = true;

      if (messageDiv && window.innerWidth < 768) {
        messageDiv.className += ' cleverpush-bell-message-open';
      }
    }
  }

  onClick() {
    logMethodCall('bell.onClick', !!this.bell);

    if (this.bell) {
      const action = () => {
        if (this.config.notificationBellMoreButtons) {
          this.toggleMoreButtons();
          return;
        }

        if (this.isSubscribed) {
          this.showPanel();
        } else {
          this.subscribe();
        }
      };

      if (typeof this.handleLoadSdk === 'function') {
        this.setLoading();
        this.handleLoadSdk().then(() => {
          window.CleverPush.waitForBell().then(() => {
            this.bell.parentNode.removeChild(this.bell);
            window.CleverPush.bell.onClick();
          });
        }).catch((e) => {
          log.error('Bell loading failed', e);
        });
      } else {
        action();
      }
    }
  }
}
